import teqIcon from "../../../assets/icons/teq-mobility.png";
import bonzahIcon from "../../../assets/img/bonzah-logo.svg";
import { isStateCoveredByTeqMobility } from "../../insurance/lib/insuranceSaleApi";

const ONBOARDING_INSURANCE_CATALOG = [
    {
        id: 1,
        img: teqIcon,
        nameKey: "steps.paymentInsurance.teqName",
        provider: "teqmobility",
        descriptionKey: "integrations.insuranceProviderDescription",
    },
    {
        id: 3,
        img: bonzahIcon,
        nameKey: "steps.paymentInsurance.bonzahName",
        provider: "bonzah",
        descriptionKey: "integrations.bonzahProviderDescription",
    },
];

export const isTeqMobilityAvailableForState = (stateValue, coverageStates) =>
    isStateCoveredByTeqMobility(stateValue, coverageStates);

/** Teq in Teq-covered states; otherwise Bonzah only (no Axle during onboarding). */
export const getOnboardingInsuranceProviderKeys = (stateValue, coverageStates) => {
    if (isTeqMobilityAvailableForState(stateValue, coverageStates)) {
        return ["teqmobility"];
    }
    return ["bonzah"];
};

export const buildOnboardingInsuranceProviders = (stateValue, coverageStates) => {
    const allowed = new Set(getOnboardingInsuranceProviderKeys(stateValue, coverageStates));
    return ONBOARDING_INSURANCE_CATALOG.filter((entry) => allowed.has(entry.provider));
};

export const isProviderEnabled = (entry) => entry?.enabled === true || entry?.enabled === "true";

export const hasRequiredOnboardingInsurance = (myCompanyData, providerKeys) => {
    const insuranceArray = myCompanyData?.insurance || [];
    return providerKeys.some((providerKey) => {
        const companyProvider = insuranceArray.find((item) => item.provider === providerKey);
        return isProviderEnabled(companyProvider);
    });
};

/** Prefer company address state; fall back to first active location. */
export const resolveCompanyLocationState = (myCompanyData, locations = []) => {
    const fromCompany = myCompanyData?.address?.state;
    if (fromCompany?.trim()) {
        return fromCompany.trim();
    }
    const firstLocation = locations.find((loc) => !loc?.isDeleted) || locations[0];
    return firstLocation?.state?.trim() || "";
};
